import { SignatureMaker } from '@docuseal/signature-maker-react'
import { useCheckoutParticipantDirectly } from 'api/Event/Attendance'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { useFileUploadRequest } from 'api/FileUpload'

const CheckOutFromDevice = ({
  eventId,
  familyId,
  checkOutNotes,
  checkInId,
  participanType,
  participantId,
  pickUpPerson,
}) => {
  const { mutate, isLoading } = useCheckoutParticipantDirectly()
  const {
    setCheckOutFromThisDeviceModalOpen,
    setCheckOutModalOpen,
    setCheckInOutModalOpen,
  } = eventAttendanceStore(store => ({
    setCheckOutFromThisDeviceModalOpen:
      store.setCheckOutFromThisDeviceModalOpen,
    setCheckOutModalOpen: store.setCheckOutModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
  }))

  const { mutate: FileUploadMutation, isLoading: fileUploadMutationLoading } =
    useFileUploadRequest()

  const handleSave = event => {
    if (fileUploadMutationLoading || isLoading) {
      return
    }
    const blob = event.blob
    const formData = new FormData()
    formData.append('signature', blob, 'signature.png')

    let newFile = {
      title: 'session',
      description: 'image_id',
      altText: 'img',
      sourceType: 'user_profile',
    }

    FileUploadMutation(
      { payload: formData, newFile },
      {
        onSuccess: data => {
          const payload = {
            signatureImageId: data._id,
            checkInId,
            checkOutNotes,
            familyId,
            eventId,
            [`${participanType}Id`]: participantId,
            pickUpPerson,
          }
          mutate(payload as any, {
            onSuccess: () => {
              setCheckOutFromThisDeviceModalOpen(false)
              setCheckOutModalOpen(false)
              setCheckInOutModalOpen(true)
            },
          })
        },
      },
    )
  }

  return (
    <div>
      <SignatureMaker
        uploadTypeButtonText={
          fileUploadMutationLoading
            ? 'Uploading signature...'
            : isLoading
            ? 'Checking-out...'
            : 'Check-out'
        }
        onSave={handleSave}
      />
    </div>
  )
}

export default CheckOutFromDevice
